export const isTrackingQueryParam = (key: string) => {
  const normalizedKey = key.toLowerCase();
  return (
    normalizedKey.startsWith('utm_') ||
    normalizedKey === 'session_id' ||
    normalizedKey === 'dhpayload'
  );
};

export const stripTrackingQueryParams = <T extends Record<string, any>>(query: T) =>
  Object.fromEntries(
    Object.entries(query).filter(
      ([key, value]) => key && !isTrackingQueryParam(key) && value != null,
    ),
  ) as Partial<T>;
